/**
 * Mar Amoli — Código de descuento en carrito (drawer + página /cart).
 *
 * Mecanismo verificado en la tienda: POST /cart/update.js {discount} aplica
 * el código y la respuesta trae discount_codes:[{code, applicable}]. Un
 * código inválido/ no aplicable devuelve applicable:false y total_discount 0.
 * {discount:''} limpia todos los códigos.
 *
 * Delegación a nivel document para sobrevivir al re-render del drawer.
 */
(function () {
  'use strict';

  function update(discount, wantSection) {
    const body = { discount: discount };
    if (wantSection) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function findCode(cart, code) {
    return (cart.discount_codes || []).find(function (d) {
      return d.code && d.code.toLowerCase() === code.toLowerCase();
    });
  }

  function rerenderDrawer(cart) {
    if (window.MaCart && cart.sections && cart.sections['cart-drawer']) {
      window.MaCart.renderSection(cart.sections['cart-drawer'], cart.item_count);
      document.dispatchEvent(new CustomEvent('ma:cart:changed'));
      return true;
    }
    return false;
  }

  function setMsg(wrap, kind, text) {
    if (!wrap) return;
    const msg = wrap.querySelector('[data-ma-discount-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    msg.classList.remove('is-error', 'is-ok');
    msg.classList.add(kind === 'error' ? 'is-error' : 'is-ok');
  }

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-ma-discount-form]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('[data-ma-discount-input]');
    const code = (input && input.value || '').trim();
    if (!code) return;
    const inDrawer = !!form.closest('ma-cart-drawer');
    const btn = form.querySelector('[data-ma-discount-apply]');
    if (btn) { btn.disabled = true; btn.dataset.loading = '1'; }

    update(code, inDrawer)
      .then(function (cart) {
        const found = findCode(cart, code);
        if (found && found.applicable) {
          // Válido: re-render (drawer) o recarga (página) para reflejar el
          // chip de código aplicado + la fila de descuento en los totales.
          if (inDrawer && rerenderDrawer(cart)) return;
          window.location.reload();
        } else {
          // Inválido: limpiar el código para que no quede pegado, y avisar.
          return update('', inDrawer).then(function (cart2) {
            const wrapBefore = form.closest('[data-ma-discount]');
            if (inDrawer && rerenderDrawer(cart2)) {
              // El footer se re-renderizó: el form (y su msg) son nuevos.
              const fresh = document.querySelector('ma-cart-drawer [data-ma-discount]');
              setMsg(fresh, 'error', 'Ese código no es válido o no aplica a tu carrito.');
              const freshInput = fresh && fresh.querySelector('[data-ma-discount-input]');
              if (freshInput) freshInput.value = code;
            } else {
              setMsg(wrapBefore, 'error', 'Ese código no es válido o no aplica a tu carrito.');
              if (btn) { btn.disabled = false; delete btn.dataset.loading; }
            }
          });
        }
      })
      .catch(function () {
        setMsg(form.closest('[data-ma-discount]'), 'error', 'No se pudo aplicar. Intenta de nuevo.');
        if (btn) { btn.disabled = false; delete btn.dataset.loading; }
      });
  });

  document.addEventListener('click', function (e) {
    const rm = e.target.closest('[data-ma-discount-remove]');
    if (!rm) return;
    e.preventDefault();
    rm.disabled = true;
    const inDrawer = !!rm.closest('ma-cart-drawer');
    update('', inDrawer)
      .then(function (cart) {
        if (inDrawer && rerenderDrawer(cart)) return;
        window.location.reload();
      })
      .catch(function () { rm.disabled = false; });
  });
})();
